import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Heading, Paragraph, Skeleton } from '@digdir/designsystemet-react';
import { OrganizationLayout } from '../../../components/OrganizationLayout';
import { useBusinessProfileQuery } from '../../../hooks/queries/organization/useBusinessProfileQuery';
import { BusinessProfileForm } from './BusinessProfileForm';

/** The organisation admin keeps the formal facts about the business for the reports to the authorities */
export const OrganizationBusinessPage = (): ReactElement => {
  const { t } = useTranslation();
  const profile = useBusinessProfileQuery();

  return (
    <OrganizationLayout>
      {profile.isLoading && (
        <div aria-busy="true">
          <span className="ds-sr-only">{t('organizationBusiness.loading')}</span>
          <Skeleton variant="rectangle" width="100%" height={420} />
        </div>
      )}
      {profile.isError && (
        <Alert data-color="danger">
          <Heading level={2} data-size="2xs">
            {t('organizationBusiness.errorTitle')}
          </Heading>
          <Paragraph>{t('organizationBusiness.errorMessage')}</Paragraph>
        </Alert>
      )}
      {profile.data && <BusinessProfileForm saved={profile.data} />}
    </OrganizationLayout>
  );
};
